import {
    CollectionServiceType, DeliveryServiceType, TransportModeRoad,
} from 'app/enums/label.enums'

export const showFTL = (transportModeRoad) => {
    return [
        TransportModeRoad.FTL,
        TransportModeRoad.FTL_OR_LTL,
    ].includes(transportModeRoad)
}

export const showLTL = (transportModeRoad) => {
    return [
        TransportModeRoad.LTL,
        TransportModeRoad.FTL_OR_LTL,
    ].includes(transportModeRoad)
}

export const isDeliveryRoad = (deliveryServiceType) => {
    return deliveryServiceType === DeliveryServiceType.DELIVERY_ROAD
}

export const isCollection = (collectionServiceType) => {
    return [
        CollectionServiceType.COLLECTION,
        CollectionServiceType.DROPOFF_AIRPORT,
    ].includes(collectionServiceType)
}

export const isCollectionOnly = (type) => {
    return type === CollectionServiceType.COLLECTION
}
